// Mock data for Educator Portal

export const currentEducator = {
  id: "EDU-001",
  phone: "+91-9876543210",
  name: "Dr. Priya Sharma",
  email: "priya.sharma@email.com",
  photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=face",
  qualifications: ["M.Ed", "B.Sc Mathematics", "PhD Education"],
  subjects: ["Mathematics", "Science"],
  experience: "12 years",
  currentInstitute: "Delhi Public School, Greater Noida",
  aadhaarVerified: true,
  createdAt: "2024-01-10"
};

export const educatorAssessments = [
  {
    id: "ASSESS-001",
    domain: "Mathematics",
    level: "Secondary (Class 9-10)",
    status: "certified",
    certificateId: "SBA-EDU-2024-001234",
    certificationLevel: "A",
    issuedDate: "2024-01-15",
    validTill: "2026-01-15",
    part1Score: 85,
    part2Score: 88,
    compositeScore: 86,
    center: "Delhi Assessment Center",
    centerCity: "New Delhi",
    competencyReport: {
      subjectKnowledge: 92,
      pedagogicalSkills: 85,
      digitalLiteracy: 78,
      adaptiveTeaching: 88,
      behavioralProfile: "Innovative Facilitator",
      strengths: ["Strong conceptual clarity", "Excellent student engagement", "Creative problem-solving"],
      developmentAreas: ["Digital tool integration", "Assessment design"]
    }
  },
  {
    id: "ASSESS-002",
    domain: "Science",
    level: "Secondary (Class 9-10)",
    status: "part1_completed",
    part1Score: 82,
    part1CompletedDate: "2024-12-20",
    part2ScheduledDate: null,
    center: null,
    centerCity: null
  }
];

export const availableDomains = [
  { id: "math-primary", domain: "Mathematics", level: "Primary (Class 1-5)" },
  { id: "math-secondary", domain: "Mathematics", level: "Secondary (Class 9-10)" },
  { id: "science-secondary", domain: "Science", level: "Secondary (Class 9-10)" },
  { id: "english-primary", domain: "English Language", level: "Primary (Class 1-5)" },
  { id: "physics-senior", domain: "Physics", level: "Senior Secondary (Class 11-12)" }
];

export const paymentHistory = [
  { id: "PAY-001", date: "2024-01-05", amount: 9999, description: "Assessment Fee - Mathematics", status: "completed", transactionId: "TXN123456789" },
  { id: "PAY-002", date: "2024-12-15", amount: 4999, description: "Additional Domain - Science", status: "completed", transactionId: "TXN987654321" }
];

export const availableSlots = [
  {
    centerId: "CTR-001",
    centerName: "Delhi Assessment Center",
    address: "Plot 45, Sector 18, Dwarka, New Delhi - 110078",
    slots: [
      { date: "2025-01-20", time: "10:00 AM", available: 5 },
      { date: "2025-01-22", time: "10:00 AM", available: 8 },
      { date: "2025-01-25", time: "2:00 PM", available: 6 }
    ]
  }
];
